import FlawDetectionModules from './FlawDetectionModules';

export default FlawDetectionModules;
